import React from 'react';
import Privacy from '../defaults/Privacy';

export default (props) => {
  return (
    <Privacy />
  );
}
